import { render, staticRenderFns } from "./SidebarNavProfile.vue?vue&type=template&id=7d2051fe&scoped=true"
import script from "./SidebarNavProfile.vue?vue&type=script&lang=js"
export * from "./SidebarNavProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavProfile.vue?vue&type=style&index=0&id=7d2051fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2051fe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNavProfile.vue
// module id = DHpy
// module chunks = 77